<template>
  <a-layout style="min-height: 100vh">
    <a-layout-sider collapsible v-model="collapsed">
      <div class="logo" :style="collapsed ? 'height: 3%' : ''" @click="$router.push('/master')" />
      <a-menu theme="dark" :defaultSelectedKeys="[$router.currentRoute.name]" mode="inline">
        <a-menu-item key="MasterUsers" @click="$router.push('/master')">
          <a-icon type="user" />
          <span>사용자</span>
        </a-menu-item>
        <a-menu-item key="MasterLocation" @click="$router.push('/master/location')">
          <a-icon type="radar-chart" />
          <span>장소</span>
        </a-menu-item>
        <a-menu-item @click="masterSignout">
          <a-icon type="logout" />
          <span>로그아웃</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #fff; padding: 0" />
      <a-layout-content style="margin: 0 16px">
        <a-breadcrumb style="margin: 16px 0">
          <slot name="breadcrumb" />
        </a-breadcrumb>
        <div
          :style="{ padding: '12px', background: color ? '#f0f2f5' : '#fff', minHeight: '360px' }"
        >
          <div :style="{ marginBottom: color ? '' : '30px' }">
            <p style="font-size: 150%">{{ title }}</p>
            <span style="font-size: 100%">{{ description }}</span>
          </div>
          <slot />
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center">Copyright 2020. 브로 사입 all rights reserved.</a-layout-footer>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "TheHeader",
  methods: mapActions(["masterRefreshMe", "masterSignout"]),
  props: ["title", "description", "color"],
  data() {
    return { collapsed: !this.isPC };
  },
  mounted() {
    this.masterRefreshMe();
  }
};
</script>
<style>
.logo {
  height: 4.2em;
  width: auto;
  background-image: url("/assets/images/static/img_logo_type2.png");
  background-repeat: no-repeat;
  background-size: 100%;
  margin: 16px;
}
</style>